const PERMISSIONS_KEY = "lamusica_cms_user_permissions";

const getPermissions = () => {
  const permissions = localStorage.getItem(PERMISSIONS_KEY)
  return permissions ? JSON.parse(permissions) : [];
};

const savePermissions = (permissions) => {
  localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions));
};

const destroyPermissions = () => {
  localStorage.removeItem(PERMISSIONS_KEY);
};

const checkPermissionEntry = (permissions, entry) => {
  for (const permission of permissions) {
    if (permission.indexOf(entry) === 0) { //permission needs to start with the given entry
      return true
    }
  }

  return false
}

const checkPermission = (entry) => {
  const permissions = getPermissions()

  if(typeof entry === 'string') {
    return checkPermissionEntry(permissions, entry)
  }

  for(const key of entry) {
    if(checkPermissionEntry(permissions, key)) {
      return true
    }
  }

  return false
}

export default { getPermissions, savePermissions, destroyPermissions, checkPermission };
